module.exports = __webpack_public_path__ + "static/media/stars.b8bc0e75.png";